import React, { Fragment, useEffect, useState } from 'react'
import moment from 'moment/moment'
import { useReduxSelector } from '../../hooks'
import { StartPage } from '../start'

export const StartAction: React.FC = ({ children }): JSX.Element => {
  const { data: constants, init: isConstants } = useReduxSelector((state) => state.constants)

  const { IS_PROJECT_START_ACTION, NOW = 0, TIMER = [] } = constants || {}

  const [timer, setTimer] = useState<any>(undefined)

  useEffect(() => {
    Object.entries(TIMER).map(([_, val]) => setTimer(val))
  }, [])

  if (IS_PROJECT_START_ACTION && isConstants) {
    return <Fragment>{children}</Fragment>
  }

  return <>{timer && <StartPage timeStart={moment(timer.endDatetime).valueOf()} text={timer.title} />}</>
}
